<template>
    <Layout>
        <div class="row">
            <div class="col-md-12">
                <b-card>
                    <PageHeader :title="title" :items="items" style="margin-top: -30px" />
                    <form action="">
                        <div class="form-row">
                            <div class="col-md-6 col-sm-6 col-lg-5">
                                <label for="trade_id" class="col-form-label col-form-label-sm">Select Trade</label>
                                <select v-model="search_data.trade_id" id="trade_id" name="trade_id"
                                    class="form-control form-control-sm">
                                    <option :value="''" selected>Select Trade</option>
                                    <option v-for="(trade, index) in trades" :key="index" :value="trade.id">
                                        {{ trade.id }} : {{ trade.desc }}
                                    </option>
                                </select>
                                <div class="invalid-feedback">
                                    Please Select Trade
                                </div>
                            </div>
                            <div class="col-md-6 col-sm-6 col-lg-5">
                                <label for="batch_no" class="col-form-label col-form-label-sm">Select Batch</label>
                                <select v-model="search_data.batch_no" id="batch_no" name="batch_no"
                                    class="form-control form-control-sm">
                                    <option :value="''" selected>Select Batch no.</option>
                                    <option value="01">01</option>
                                    <option value="02">02</option>
                                    <option value="03">03</option>
                                    <option value="04">04</option>
                                    <option value="05">05</option>
                                    <option value="06">06</option>
                                    <option value="07">07</option>
                                    <option value="08">08</option>
                                    <option value="09">09</option>
                                    <option value="10">10</option>
                                    <option value="11">11</option>
                                    <option value="12">12</option>
                                    <option value="13">13</option>
                                    <option value="14">14</option>
                                    <option value="15">15</option>
                                    <option value="16">16</option>
                                    <option value="17">17</option>
                                    <option value="18">18</option>
                                    <option value="19">19</option>
                                    <option value="20">20</option>
                                    <option value="21">21</option>
                                    <option value="22">22</option>
                                    <option value="23">23</option>
                                    <option value="24">24</option>
                                    <option value="25">25</option>
                                </select>
                                <div class="invalid-feedback">
                                    Please Select Batch
                                </div>
                            </div>
                            <div class="col-md-6 col-sm-6 col-lg-2 custom-search">
                                <button class="btn btn-success btn-sm custom-search-button"
                                    @click.prevent="search">Search</button>
                            </div>
                        </div>
                    </form>
                </b-card>
                <b-card v-if="!flag">
                    <div class="row mb-2">
                        <div class="col-sm-12">
                            <span class="badge badge-success">Total Search Data Found: {{ batches.total }}</span>
                            <download-excel class="btn btn-light float-right" :fetch="fetchData"
                                :fields="attendance_fields" :meta="json_meta" worksheet="Attendance"
                                name="attendance-report.xls">
                                Download Excel
                            </download-excel>

                            <button class="btn btn-light float-right mr-1" @click="dowonloadPdf">
                                <div v-if="loading" class="spinner-border spinner-border-sm text-muted"
                                    style="margin-bottom : 2px;">
                                </div>
                                Download PDF
                            </button>
                        </div>
                    </div>

                    <div class="table-responsive" style="overflow-x: auto">
                        <table class="table table-centered table-striped">
                            <thead>
                                <tr>
                                    <th>Sl</th>
                                    <th>Trade | Batch</th>
                                    <th>Venue</th>
                                    <th>Total Trainee</th>
                                    <th>Male</th>
                                    <th>Female</th>
                                    <th>Total Present</th>
                                    <th>Total Absence</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(batch, index) in batches.data" :key="index">
                                    <td>{{ batches.from + index }}</td>
                                    <td>
                                        <router-link :to="{
                                            name: 'batchView',
                                            params: { batch_id: batch.id }
                                        }" tag="a" target="_blank">{{ batch.trade.desc }}
                                            | {{ batch.batch_no }}
                                        </router-link>
                                    </td>
                                    <td>{{ batch.venue.desc }}</td>
                                    <td>{{ batch.totalTrainee }}</td>
                                    <td>{{ batch.traineeMaleCount }}</td>
                                    <td>{{ batch.traineeFemaleCount }}</td>
                                    <td>{{ batch.traineePresent }}</td>
                                    <td>{{ batch.traineeAbsent }}</td>
                                </tr>
                            </tbody>
                        </table>
                        <h5 v-if="batches.total === 0" class="text-center text-secondary">
                            No Data Found
                        </h5>
                        <div class="float-right">
                            <pagination :data="batches" :limit="2" @pagination-change-page="getResults"></pagination>
                        </div>
                    </div>
                </b-card>
            </div>
        </div>
    </Layout>
</template>

<script>

import appConfig from "@src/app.config";
import Layout from "@layouts/main";
import PageHeader from "@components/page-header";
import http from "@state/http";
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';

export default {
    page: {
        title: "Attendance Report",
        meta: [{ name: "description", content: appConfig.description }]
    },
    components: { Layout, PageHeader },
    data() {
        return {
            loading: false,
            title: "Attendance Report",
            items: [
                {
                    text: "Dashboard",
                    href: "/"
                },
                {
                    text: "Attendance Report",
                    active: true
                }
            ],
            trades: [],
            batches: [],
            search_data: {
                trade_id: '',
                batch_no: ''
            },
            attendance_counts: {},
            attendance_fields: {
                'Trade | Batch': {
                    callback: (value) => {
                        return `${value.trade.desc} | ${value.batch_no}`;
                    }
                },
                'Venue': {
                    callback: (value) => {
                        return `${value.venue.desc}`;
                    }
                },
                'Total Trainee': 'totalTrainee',
                'Male': 'traineeMaleCount',
                'Female': 'traineeFemaleCount',
                'Total Present': 'traineePresent',
                'Total Absence': 'traineeAbsent',
            },
            json_meta: [
                [
                    {
                        'key': 'charset',
                        'value': 'utf-8'
                    }
                ]
            ],
            flag: true
        };
    },
    mounted() {
        this.getTrades();
    },
    methods: {
        async dowonloadPdf() {
            this.loading = true
            let response = await http.post("api/trainee/batch/attendance/download", this.search_data);
            var data = []
            try {
                //console.log(response.data.batches)
                // return
                response.data.batches.forEach(function (value) {
                    data.push([
                        value.trade.desc + '|' + value.batch_no,
                        value.venue.desc,
                        value.totalTrainee,
                        value.traineeMaleCount,
                        value.traineeFemaleCount,
                        value.traineePresent,
                        value.traineeAbsent
                    ])
                })
            }
            catch (e) {
                console.log(e.message)
            }

            const doc = new jsPDF()
            autoTable(doc, {
                head: [['Trade | Batch', 'Venue', 'Total Trainee', 'Male', 'Female', 'Total Present', 'Total Absence']],
                body: data,
            })
            doc.save('attendance-report.pdf')
            this.loading = false
        },
        getTrades() {
            http.get("api/batch/trainee/getTrade").then(response => {
                if (!response.error) {
                    this.trades = response.data.trades;
                }
            });
        },
        search() {
            this.$validator.validate().then(valid => {
                if (valid) {
                    http
                        .post("api/trainee/batch/attendance/search", this.search_data)
                        .then(response => {
                            if (!response.error) {
                                this.flag = false;
                                this.batches = response.data.batches;
                            }
                        })
                        .catch(error => {
                            this.validation_errors = error.response.data.errors;
                        });
                }
            });
        },
        getResults(page = 1) {
            http.post('api/trainee/batch/attendance/search?page=' + page, this.search_data)
                .then(response => {
                    this.flag = false;
                    this.batches = response.data.batches;
                });
        },
        countMale(trainees) {
            let count = 0;
            trainees.filter(p => {
                if (p.c_rep_gender_id !== null && p.c_rep_gender_id === 1) {
                    count += 1;
                } else if (p.c_rep_gender_id === null && p.c_gender_id === 1) {
                    count += 1;
                }
            });
            return count;
        },
        countFemale(trainees) {
            let count = 0;
            trainees.filter(p => {
                if (p.c_rep_gender_id !== null && p.c_rep_gender_id === 2) {
                    count += 1;
                } else if (p.c_rep_gender_id === null && p.c_gender_id === 2) {
                    count += 1;
                }
            });
            return count;
        },
        countPresent(attendances) {
            let count = 0;
            attendances.filter(p => {
                if (p.is_attend !== null && p.is_attend === 1) {
                    count += 1;
                }
            });
            return count;
        },
        countAbsent(attendances) {
            let count = 0;
            attendances.filter(p => {
                if (p.is_attend !== null && p.is_attend === 0) {
                    count += 1;
                }
            });
            return count;
        },
        async fetchData() {
            const response = await http.post("api/trainee/batch/attendance/download", this.search_data);
            return response.data.batches;
        },
    },
};
</script>



